import { useMemo } from "react";
import { doc } from "firebase/firestore";
import { useDocument } from "react-firebase-hooks/firestore";

import { getOrganisationsCollection } from "integrations/firebase/collections";
import {
  isRunningInMeticulous,
  METICULOUS_ORGANISATION,
} from "integrations/meticulous";

export const useOrganisation = (organisationId?: string) => {
  const isMeticulous = isRunningInMeticulous();
  const [snapshot, loading, error] = useDocument(
    organisationId && !isMeticulous
      ? doc(getOrganisationsCollection(), organisationId)
      : null,
  );

  return useMemo(() => {
    if (isMeticulous) {
      return {
        data: METICULOUS_ORGANISATION,
        loading: false,
        error: undefined,
      };
    }

    // When the id changes, the hook reports the previous snapshot as loaded
    // for one render, so a snapshot for another id still counts as loading.
    const isCurrent = snapshot?.id === organisationId;

    return {
      data: isCurrent ? snapshot?.data() : undefined,
      loading: loading || (Boolean(organisationId) && !isCurrent && !error),
      error,
    };
  }, [isMeticulous, snapshot, loading, error, organisationId]);
};
